/**
 * Param/banka veya API'nin döndüğü mesajda kart/CVV/SKT ile düzeltilebilir hata olup olmadığını tahmin eder.
 * Abonelik + reklam ödemesi için kullanılır. Backend SubscriptionController ile liste uyumlu tutulmalı.
 */
export function isRecoverableSubscriptionPaymentMessage(text: string | undefined | null): boolean {
  if (!text || !String(text).trim()) return false;
  const t = String(text).trim().toLowerCase();
  const keys = [
    'cvv',
    'cvc',
    'cvc2',
    'skt',
    'son kullanma',
    'son kullanım',
    'son kullanim',
    'güvenlik kodu',
    'guvenlik kodu',
    'security code',
    'expir',
    'kart bilgi',
    'kart numarası',
    'kart numarasi',
    'kredi kartı',
    'kredi karti',
    'kart no',
    'geçersiz',
    'gecersiz',
    'yanlış',
    'yanlis',
    'hatalı',
    'süresi',
    'suresi',
    'doğrula',
    'dogrula',
    'bilgilerinizi kontrol',
    'bilgilerinizi kontrol edin',
    'invalid card',
    'expired card',
    'wrong cvv',
    'incorrect cvv',
    'invalid cvc',
    'invalid expiry',
    'doğrulanamadı',
    'dogrulanamadi',
    'not authenticated',
    'authentication failed',
    'işlem reddedildi',
    'islem reddedildi',
    'provizyon alınamadı',
    'provizyon alinamadi',
    'ödeme reddedildi',
    'odeme reddedildi',
  ];
  return keys.some((k) => t.includes(k));
}

/** Alias — abonelik dışı Param ödemeleri (ör. reklam) için aynı kural. */
export const isRecoverableCardPaymentInputMessage = isRecoverableSubscriptionPaymentMessage;
